import styled from 'styled-components'
import { SIZES } from '../../../../../constants'

export default styled.ul`
  padding: 0;
  margin-bottom: 7px;
  @media (max-width: ${SIZES.BREAKPOINT_MD - 1}px) {
    display: none;
  }
`
